module.exports = __webpack_public_path__ + "img/less-hallucination.f3f1a623.png";